export const LANGUAGE_STORAGE_KEY = 'rozops_language';

export const languageOptions = [
  ['en', 'English'],
  ['as', 'Assamese'],
  ['bn', 'Bengali'],
  ['brx', 'Bodo'],
  ['doi', 'Dogri'],
  ['gu', 'Gujarati'],
  ['hi', 'Hindi'],
  ['kn', 'Kannada'],
  ['ks', 'Kashmiri'],
  ['kok', 'Konkani'],
  ['mai', 'Maithili'],
  ['ml', 'Malayalam'],
  ['mni-Mtei', 'Manipuri'],
  ['mr', 'Marathi'],
  ['ne', 'Nepali'],
  ['or', 'Odia'],
  ['pa', 'Punjabi'],
  ['sa', 'Sanskrit'],
  ['sat', 'Santali'],
  ['sd', 'Sindhi'],
  ['ta', 'Tamil'],
  ['te', 'Telugu'],
  ['ur', 'Urdu'],
];

export const includedLanguages = languageOptions.map(([code]) => code).join(',');
